<template>

  <section class="numeros-medios">
    <div class="container">
      <div class="cont-numeros">
        <div class="numeros">
          <div class="num-counter">
            +${{ millionInvested }}
          </div>
          Millones financiados
        </div>
        <div class="numeros">
          <div class="num-counter">
            +{{ formatIntegerNumbers(investment) }}
          </div>
          Inversiones
        </div>
        <div class="numeros">
          <div class="num-counter">
            +{{ formatIntegerNumbers(financedCredits) }}
          </div>
          Créditos financiados
        </div>
      </div>
      <div class="cont-medios">
        <a class="btn-news" href="http://noticias.cumplo.mx/" target="_blank">Noticias <img src="/static/svg/icons_fontawesome-chevron-right.svg"></a>
      </div>
    </div>
  </section>

</template>

<script>

import mixins from '@/mixins/index'

export default {
  name: 'BottomInfo',
  mixins: [mixins],
  data () {
    return {
      millionInvested: process.env.MILLION_INVESTED,
      investment: process.env.INVESTMENTS,
      financedCredits: process.env.FINANCED_CREDITS
    }
  }
}

</script>

<style lang="scss" scoped>

.solicitar .cont-numeros {
  margin-top: 4rem;

  .numeros {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin: 8px;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: $white;
    line-height: 1;
    text-align: center;
    font-size: 1em;
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  .icon {
    margin-right: 10px;
  }
}

.numeros-medios {
  overflow: hidden;
}

.numeros-medios .container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch
}

.numeros-medios .cont-numeros {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-right: auto;
  width: 100%;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  padding: 30px 0
}

.numeros-medios .cont-medios {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding: 0 15px;
  position: relative;
  justify-content: center;
  background: $green;
}

.numeros-medios .cont-medios:after {
  content: '';
  height: 100%;
  width: 500%;
  position: absolute;
  right: -500%;
  top: 0;
  background: #3b454e
}

.numeros-medios .cont-medios .btn-news {
  display: block;
  width: 100%;
  text-align: center;
  color: #fff;

  > img {
    margin: 0 0 -5px 10px;
  }
}

@media only screen and (max-width: 860px) {
  .numeros-medios .container {
    -webkit-flex-direction:column;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .numeros-medios .cont-numeros {
    width: 100%
  }

  .numeros-medios .cont-medios {
    width: 100%;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
  }

  .numeros-medios .cont-medios:before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: -100%;
    top: 0;
    background: #3b454e
  }
}
¡

.numeros-solo {
  padding: 40px 0
}

.cont-numeros {
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: initial;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.cont-numeros .numeros {
  text-align: center;
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 3px;
}

@media only screen and (max-width: 1300px) {
  .cont-numeros .numeros {
    font-size: 1em
  }
}

@media only screen and (max-width: 640px) {
  .cont-numeros .numeros {
    margin: 20px 0
  }
}

.cont-numeros .numeros .num-counter {
  display: block;
  font-size: 3.4em;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1;
}

.numeros--small {
  font-size: .8em;
  display: block;
  margin-top: .3em
}

@media only screen and (max-width: 640px) {
  .cont-numeros .numeros {
    font-size:.9em
  }
}

</style>



// WEBPACK FOOTER //
// src/partials/BottomInfo.vue